/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Paid_Amount_PositiveInputs */

const vi_tea_purchase_paid_amount_positive = /** @type {(inputs: Tea_Purchase_Paid_Amount_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền phải lớn hơn 0`)
};

/**

* @param {Tea_Purchase_Paid_Amount_PositiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_paid_amount_positive = /** @type {((inputs?: Tea_Purchase_Paid_Amount_PositiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Paid_Amount_PositiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_paid_amount_positive(inputs)
});